import { Utils } from "../../../../../../../services/utils.service";
import { DataCollection } from "../../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../../infrastructure/enums";
import { TransportData } from "../../../../../../infrastructure/transportdata";


export class ActiveAshaEmployeeHierarchyFetchRequest {
    public static readonly FetchRequestType: string = "active_asha_employee_hierarchy_fetch_request";
asha_employee_record_ids: number[] = [];
af_employee_record_ids: number[] = [];
under_supervision_ids: number[] = [];
village_ids: number[] = [];
zone_ids: number[] = [];
district_ids: number[] = [];
block_ids: number[] = [];
bcm_post_ids: number[] = [];
phc_ids: number[] = [];
af_post_ids: number[] = [];
af_ids: number[] = [];
financial_year_id: number = 0;
month: number = 0;
hierarchy_level: number = 0;


    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, ActiveAshaEmployeeHierarchyFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

